module.exports = __webpack_public_path__ + "img/selos.01585893.png";